import React from 'react'
import FbIcon from 'images/icons/fb.inline.svg'
import LinkedinIcon from 'images/icons/linkedin.inline.svg'
import InstaIcon from 'images/icons/insta.inline.svg'
import XIcon from 'images/icons/x.inline.svg'
import YtIcon from 'images/icons/yt.inline.svg'
import GithubIcon from 'images/icons/github.inline.svg'
import { footer, quickLinks, icons, legal } from './footer.module.scss'

function Footer(){
    return (
        <footer className={footer}>
              <div>
                <ul className={icons}>
                    <li>
                        <a href="https://www.facebook.com/lucidworks/" target="_blank" rel="noreferrer">
                            <FbIcon />
                        </a>
                    </li>
                    <li>
                        <a href="https://linkedin.com/company/lucidworks" target="_blank" rel="noreferrer">
                            <LinkedinIcon />
                        </a> 
                    </li> 
                    <li>
                        <a href="https://www.instagram.com/lucidworkshq/" target="_blank" rel="noreferrer">
                            <InstaIcon />
                        </a>
                    </li>
                    <li>
                        <a href="https://twitter.com/Lucidworks" target="_blank" rel="noreferrer">
                            <XIcon />
                        </a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/user/LucidWorksSearch" target="_blank" rel="noreferrer">
                            <YtIcon />
                        </a>
                    </li>
                    <li>
                        <a href="https://github.com/lucidworks" target="_blank" rel="noreferrer">
                            <GithubIcon />
                        </a>
                    </li>
                </ul>
                <p style={{marginBottom: '0', color: 'var(--color-text-3', fontSize: '0.7rem'}}> © 2024 Lucidworks</p>
                <p style={{marginBottom: '0', color: 'var(--color-text-3', fontSize: '0.7rem'}}><a className={legal} href="https://lucidworks.com/legal/" target="_blank" rel="noreferrer">Legal agreements</a> | <a className={legal} href="https://lucidworks.com/legal/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a></p>
              </div>
              <aside className={quickLinks}>
                <div style={{marginRight:'1em'}}>
                    <p>Who are we? <a href="https://lucidworks.com/company/" target="_blank" rel="noreferrer"><span className="underline">Learn about Lucidworks</span></a></p>
                    <p>Ready to join? <a href="https://lucidworks.com/demo/" target="_blank" rel="noreferrer"><span className="underline">Request demo</span></a></p>
                </div> 
                <div>
                    <p>Need help? <a href="https://support.lucidworks.com/" target="_blank" rel="noreferrer"><span className="underline">Contact support</span></a></p>
                    <p>Need training? <a href="https://academy.lucidworks.com/" target="_blank" rel="noreferrer"><span className="underline">Visit LucidAcademy</span></a></p>
                </div>
              </aside>
      </footer>
    )
}

export default Footer